import albedo, {intentInterface, intentErrors} from './index.js'

albedo.intentInterface = intentInterface
albedo.intentErrors = intentErrors

export default albedo